import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import RefreshIcon from "@mui/icons-material/Refresh";
import DateButton from "../../../components/DateButton/DateButton";
import HighlightedPickersDay from "../../../components/HighlightedPickersDay/HighlightedPickersDay";
import Buttons from "../../../components/Buttons/Buttons";
import SessionTable from "./SessionTable";

const SessionsTab = ({
  calendarOpen,
  setCalendarOpen,
  selectedDate,
  handleDateChange,
  highlightedDates,
  handleRefresh,
  rows,
  page,
  rowsPerPage,
  totalRows,
  processingSessionId,
  noT,
  formatDateOnly,
  formatSecondsToHMS,
  onView,
  onDownload,
  onDelete,
  onChangePage,
  onChangeRowsPerPage,
  isLoading,
  fetchError,
}) => {
  return (
    <div className="tab-panel-content">
      <div className="tab-panel-header">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <h3>Sessions History</h3>
          <CustomTooltip title="Refresh">
            <span>
              <Buttons
                icon={<RefreshIcon />}
                ariaLabel="Refresh"
                onClick={handleRefresh}
              />
            </span>
          </CustomTooltip>
        </div>
        <div className="patient-session-details_headers_right_calendar">
          <DatePicker
            open={calendarOpen}
            onOpen={() => setCalendarOpen(true)}
            onClose={() => setCalendarOpen(false)}
            value={selectedDate}
            onChange={(date) => handleDateChange(date ? [date] : [])}
            views={["year", "month", "day"]}
            slots={{ field: DateButton, day: HighlightedPickersDay }}
            slotProps={{
              field: {
                value: selectedDate,
                onClick: () => setCalendarOpen(true),
              },
              day: { highlightedDates },
            }}
          />
        </div>
      </div>

      <SessionTable
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        processingSessionId={processingSessionId}
        noT={noT}
        formatDateOnly={formatDateOnly}
        formatSecondsToHMS={formatSecondsToHMS}
        onView={onView}
        onDownload={onDownload}
        onDelete={onDelete}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={handleRefresh}
      />
    </div>
  );
};

export default SessionsTab;
